export enum ETariffCredentialType {
  UIC = 'UIC 918.9',
  VDVKA = 'VDV-KA',
}
